// Hand-written (not generated) — mirrors the shape of the generated handlers
// in this directory. Backend contract: POST /remediation/exam-attempt with
// exactly ONE of { subsectionExamId } (course-side graded exam) or
// { onboardingStepKey } (graded onboarding ASSESSMENT step) → { guidance }.
// The endpoint is feature-gated server-side and answers a bare 404 when the
// org doesn't have it — callers must treat 404 as "feature off", silently.
export const remediationApiHandler = {
  examAttempt: {
    method: 'POST',
    path: () => `remediation/exam-attempt`,
  },
};
